export class HomeOwnersWithOpenViolationsSummaryResultDto {
  title: string;
  violationCount: number;
  percentage: number;
}
